import apiClient from "./client";

const API_BASE = process.env.REACT_APP_API_URL || "/api/v1";

export async function getMySubmissions() {
  return apiClient.get("/submissions/my");
}

export async function getApprovedSubmissions({ page = 1, limit = 48, type = "SCREENSHOT" } = {}) {
  const params = new URLSearchParams();
  params.set("page", String(page));
  params.set("limit", String(limit));
  params.set("type", type);
  return apiClient.get(`/submissions/approved?${params.toString()}`);
}

export async function getAdminSubmissions() {
  return apiClient.get("/admin/submissions");
}

export async function deleteAdminSubmission(id) {
  return apiClient.delete(`/admin/submissions/${id}`);
}

export async function updateAdminSubmissionStatus(id, { status, rejectionReason, readGroups }) {
  return apiClient.patch(`/admin/submissions/${id}`, { status, rejectionReason, readGroups });
}

export async function createScreenshotSubmission(data) {
  const formData = new FormData();
  formData.append("image", data.image);
  formData.append("submissionType", "SCREENSHOT");
  if (data.pwarp) formData.append("pwarp", data.pwarp);
  if (data.owner) formData.append("owner", data.owner);
  if (data.description) formData.append("description", data.description);
  if (data.buildCredits) formData.append("buildCredits", data.buildCredits);

  const headers = {};
  if (apiClient.accessToken) {
    headers.Authorization = `Bearer ${apiClient.accessToken}`;
  }

  const response = await fetch(`${API_BASE}/submissions`, {
    method: "POST",
    headers,
    body: formData,
  });

  const payload = await response.json();
  if (!response.ok) {
    const err = new Error(payload.error || "Submission failed");
    err.status = response.status;
    throw err;
  }
  return payload;
}
